export enum SessionPersistConstants {
  SET_IS_HYDRATING = 'persistSession/SET_IS_HYDRATING',
  SET_SHOW_MODAL = 'persistSession/SET_SHOW_MODAL',
  SET_PIN_VALUES = 'persistSession/SET_PIN_VALUES',
  SET_IS_RESUMING = 'persistSession/SET_IS_RESUMING',
  SET_ERROR_MESSAGE = 'persistSession/SET_ERROR_MESSAGE',
  SET_METADATA = 'persistSession/SET_METADATA',
  RESET_STATE = 'persistSession/RESET_STATE',
  REHYDRATE = 'persistSession/REHYDRATE',
  RESET_STORE = 'persistSession/RESET_STORE',
}
